export class Logger {
    public logLevel: LogLevel;

    constructor() {
        this.logLevel = LogLevel.Info;
    }

    info(message: string, exception: Error = null) {
        if (this.logLevel != LogLevel.Info)
            return;
        
        if (exception) {
            console.log(`Info: ${message}. ${exception.message}`);
        } else {
            console.log(`Info: ${message}.`);
        }
    }
    
    warn(message: string, exception: Error = null) {
        if (this.logLevel != LogLevel.Warn && this.logLevel != LogLevel.Info)
            return;

        if (exception) {
            console.log(`Warning: ${message}. ${exception.message}`);
        } else {
            console.log(`Warning: ${message}.`);
        }
    }

    error(message: string, exception: Error = null) {
        if (this.logLevel != LogLevel.Error && this.logLevel != LogLevel.Warn && this.logLevel != LogLevel.Info)
            return;

        if (exception) {
            console.log(`Error: ${message}. ${exception.message}`);
        } else {
            console.log(`Error: ${message}.`);
        }
    }
}

export enum LogLevel {
    Info = 0,
    Warn = 1,
    Error = 2
}
